import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/design-system/utils/cn";
import type { Job } from "~/types/job";
export function PrintviewJobad(t0) {
  const $ = _c(6);
  const {
    job
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("task", "box-decoration-break-clone", "[&_h1]:mt-4 [&_h1]:mb-3 [&_h1]:font-bold [&_h1]:text-lg", "[&_h2]:mt-3 [&_h2]:mb-2 [&_h2]:font-bold [&_h2]:text-base", "[&_h3]:mt-2 [&_h3]:mb-2 [&_h3]:font-bold [&_h3]:text-sm", "[&_p]:mb-2 [&_p]:leading-relaxed", "[&_ul]:mb-3 [&_ul]:pl-4", "[&_li]:mb-1", "[&_hr]:hidden", "[&_*]:break-words", "[&_ul]:mb-2 [&_ul]:ml-4 [&_ul]:list-disc [&_ul]:columns-1 [&_ul]:py-1", "[&_ul+ul]:-mt-4 [&_ul+ul]:border-t-0", "[&_ul+p]:mt-1 [&_ul+p]:border-t-2 [&_ul+p]:pt-1", "[&_ul+h3]:mt-1 [&_ul+h3]:border-t-2 [&_ul+h3]:pt-1", "[&_p+h3]:mt-1 [&_p+h3]:border-t-2 [&_p+h3]:pt-1", "[&_task>p]:first:mb-1", "[&_b]:font-medium", "[&_task_h3]:text-base");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== job.content.task) {
    t2 = {
      __html: job.content.task
    };
    $[1] = job.content.task;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      lineHeight: "20px"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="col-span-6 h-min py-4 pr-8 pl-2"><div className={t1} dangerouslySetInnerHTML={t2} style={t3} /></div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}